import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Helmet } from "react-helmet";
// import Footer from "./Footer";

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>About Us | Nandan Denim Ltd .</title>
      </Helmet>

      <Header />
      <div>


      </div>

      <Footer />

    </>
  )
};

export default AboutUs;
